export const CHECK_ASSESSMENT_REQUEST = "CHECK_ASSESSMENT_REQUEST";
export const CHECK_ASSESSMENT_SUCCESS = "CHECK_ASSESSMENT_SUCCESS";
export const CHECK_ASSESSMENT_ERROR = "CHECK_ASSESSMENT_ERROR";

export const CLEAR_CHECK_ASSESSMENT_FLAG = "CLEAR_CHECK_ASSESSMENT_FLAG"